<template>
    <div :class="itemClass" @click="handleClick">
        <span v-if="showRadio" class="radio" />
        <img :src="icon" />
    </div>
</template>

<script>
import DEUTZ from '@/assets/images/deutz@2x.png';
import XINGBIDA from '@/assets/images/xingbida@2x.png';

export default {
    name: 'MerchantItem',
    props: {
        // 商户的英文名称
        merchantEnName: {
            type: String,
            required: true
        },
        // 是否显示单选框
        showRadio: {
            type: Boolean,
            default: true
        },
        // 是否选中
        checked: {
            type: Boolean,
            required: false
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        /**
         * item类名
         * @return {{"merchant-item": boolean, "is-checked": boolean, "is-disabled": boolean}}
         */
        itemClass() {
            return {
                'merchant-item': true,
                'is-checked': this.checked,
                'is-disabled': this.disabled
            };
        },
        /**
         * 支付渠道图标
         */
        icon() {
            let res = '';
            switch (this.merchantEnName) {
                case 'DEUTZ':
                    res = DEUTZ;
                    break;
                case 'XINGBIDA':
                    res = XINGBIDA;
                default:
                    break;
            }
            return res;
        }
    },
    methods: {
        /**
         * 处理点击事件
         */
        handleClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('change', this.merchantEnName, !this.checked);
        }
    }
};
</script>

<style lang="scss" scoped>
.merchant-item {
    display: flex;
    align-items: center;
    border: 1px solid #d8dce6;
    cursor: pointer;

    &:hover {
        border: 1px solid #409eff;
    }

    img {
        display: block;
        //width: 150px;
        height: 44px;
    }

    .radio {
        position: relative;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        margin: 0 2px 0 16px;
        background-color: #f0f2f5;
        border: 1px solid #d5d8de;
        border-radius: 100%;
    }
}

.merchant-item.is-checked {
    .radio {
        background: #409eff;
        border-color: #409eff;

        &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 4px;
            height: 4px;
            background-color: #fff;
            border-radius: 100%;
            transform: translate(-50%, -50%);
            content: '';
        }
    }
}

.merchant-item.is-disabled {
    border-color: #d8dce6;
    cursor: not-allowed;

    .radio {
        background-color: #f0f2f5;
        border-color: #d5d8de;
    }
}
</style>
